export default __webpack_public_path__ + "static/media/ico_cart_w.c324d640.svg";